import React from 'react';
import { Row, Col } from 'antd';
import { Header } from './Header';
import { Container } from './Container';

export function Content(): JSX.Element {
	return (
		<Row gutter={[0, 8]}>
			<Col span={24}>
				<Header />
			</Col>
			<Col span={24}>
				<Container />
			</Col>
		</Row>
	);
}
